module.exports = __webpack_public_path__ + "img/fuel-img.bb306c70.png";